import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import * as moment from 'moment';
import * as $ from 'jquery';
import 'src/assets/js/vendor/jquery.scrollbar.min';
import {ApiService} from "../_services/api.service";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit,OnDestroy,AfterViewInit {

  @ViewChild('idModalPersonalInfoQues') idModalPersonalInfoQues!: ElementRef;
  @ViewChild('isPrivacyAgreeBtn') isPrivacyAgreeBtn!: ElementRef;
  @ViewChild('idPersonalInfoScroll') idPersonalInfoScroll!: ElementRef;
  @ViewChild('idModalPersonalInfoAgreeNote') idModalPersonalInfoAgreeNote!: ElementRef;

  isAgreeViewed:boolean = false; // 個資同意是否拉到底了

  constructor(private router:Router,
              private route:ActivatedRoute,
              private apiService:ApiService) { }

  ngOnInit(): void {
    console.log('back', this.route.snapshot.queryParams.back);
    let lastID = localStorage.getItem('CODE');
    if(this.route.snapshot.queryParams.back && lastID) {
      // 返回首頁, 保持原有 ID & src
      return;
    }
    let ID = this.route.snapshot.queryParams.ID;
    console.log('場次ID', ID);
    if(ID) {
      this.apiService.verifyKey(ID).subscribe(ok=> {
        if(ok) {
          localStorage.setItem('CODE', this.route.snapshot.queryParams.ID);
          localStorage.setItem('dataSource', this.route.snapshot.queryParams.src || 'qrcode');
          let date = moment().format('YYYY/MM/DD HH:mm:ss');
          localStorage.setItem('privacyYn', date); // 開啟頁面即視為同意
        } else {
          this.invalidId();
        }
      });
    } else {
      this.invalidId();
    }
  }
  private invalidId() {
    localStorage.clear();
    alert('無效場次');
    // location.href='https://www.allianz.com.tw/zh_TW/about-us/contact-us/contact-us.html';
    this.router.navigate(['err-404']);
  }

  ngAfterViewInit() {
    // 檢查個資同意視窗是否拉到底
    let infoScroll = $(this.idPersonalInfoScroll.nativeElement);
    let ctrl = this;
    let firstMeet = true;
    infoScroll.on('scroll', function() {
      // console.log('on scroll');
      //捲到最底的判定，多加一個150px的從寬判定範圍
      if(infoScroll.scrollTop()! + infoScroll.innerHeight()! >= (infoScroll[0].scrollHeight-150)) {
        // console.log('meet');
        if(firstMeet) {
          // 套用 scrollbar 會觸發, 第一次要跳過
          firstMeet = false;
          return;
        }
        // $('[data-id="idModalPersonalInfoAgreeNote"]').addClass('ra-hide'); //close idModalPersonalInfoAgreeNote
        // $('#isPrivacyAgreeBtn').removeClass('jsBtnDisabled').prop('disabled', false);
        ctrl.isAgreeViewed = true;
        ctrl.isPrivacyAgreeBtn.nativeElement.classList.remove('jsBtnDisabled');
      }
    });

    // scrollbar on mobile
    let scrollbar:any = $('.scrollbar-inner');
    scrollbar.scrollbar();
  }

  ngOnDestroy() {
    $('body').removeClass('ra-fixed');
  }

  showAgree(): void {
    this.idModalPersonalInfoQues.nativeElement.classList.remove('ra-hide');
  }

  agree(): void {
    // let btnDisabled = this.isPrivacyAgreeBtn.nativeElement.classList.contains('jsBtnDisabled');
    let date = moment().format('YYYY/MM/DD HH:mm:ss');
    // console.log('agree btnDisabled', btnDisabled, date);
    // if(btnDisabled) {
    //   return;
    // }
    if(!this.isAgreeViewed) {
      this.idModalPersonalInfoAgreeNote.nativeElement.classList.remove('ra-hide');
      return;
    }

    localStorage.setItem('personnalDate', date);
    this.router.navigate(['roboadv-chat']);
  }

  disagree(): void {
    // localStorage.clear(); // remove all
    // 只刪除問卷資料，保留場次與個資同意時間等其他參數
    localStorage.removeItem('chat');
    localStorage.removeItem('chatStatus');

    this.router.navigate(['thx', 'delete']);
  }

}
